import { useState } from "react";
import { Controls, ControlButton, MiniMap, useReactFlow } from "@xyflow/react";
import { Box, useTheme } from "@mui/material";
import { alpha } from "@mui/system";
import CenterFocusWeakOutlined from "@mui/icons-material/CenterFocusWeakOutlined";
import MapOutlined from "@mui/icons-material/MapOutlined";
import DashboardCustomizeOutlined from "@mui/icons-material/DashboardCustomizeOutlined";
import SaveAsOutlined from "@mui/icons-material/SaveAsOutlined";
import styles from "./styles";

// Componente de controles flutuantes (zoom, minimapa, templates) do canvas do diagrama
export default function ControlesDiagrama({
  editMode = false,
  isExpanded = false,
  onToggleExpanded = () => {},
  onAbrirTemplates = () => {},
  onSalvarTemplate = () => {},
  hasNodes = false,
}) {
  // Controle de exibição do minimapa
  const [minimapExpanded, setMinimapExpanded] = useState(false);

  // Tema atual da aplicação
  const theme = useTheme();

  // Acessa ações de enquadramento da viewport do React Flow
  const { fitView } = useReactFlow();

  // Estilos da pilha de controles
  const controlStyles = styles(theme);

  // Alterna a exibição do minimapa
  const toggleMinimap = () => setMinimapExpanded((prev) => !prev);

  return (
    <Box sx={controlStyles.floatingControlsStack}>
      {minimapExpanded && (
        <MiniMap
          pannable
          zoomable
          nodeColor={(node) =>
            node?.data?._colorSwatch?.border || theme?.palette?.primary?.main
          }
          nodeStrokeColor={theme?.palette?.primary?.dark}
          nodeStrokeWidth={2}
          maskColor={alpha(
            theme?.palette?.background?.default || "#fff",
            0.55,
          )}
          style={{
            ...controlStyles.miniMap,
            ...controlStyles.controlsInStack,
          }}
        />
      )}
      <Controls
        showInteractive={false}
        showFitView={false}
        style={controlStyles.controlsInStack}
      >
        {/* Botão de centralizar e ajustar zoom do diagrama */}
        <ControlButton
          onClick={() => fitView({ padding: 0.2 })}
          title="Centralizar diagrama"
          aria-label="Centralizar diagrama"
        >
          <CenterFocusWeakOutlined fontSize="small" />
        </ControlButton>
        {/* Botão de alternar exibição do minimapa */}
        <ControlButton
          onClick={toggleMinimap}
          title={minimapExpanded ? "Ocultar minimapa" : "Exibir minimapa"}
          aria-label={
            minimapExpanded ? "Ocultar minimapa" : "Exibir minimapa"
          }
        >
          <MapOutlined
            fontSize="small"
            sx={{
              color: minimapExpanded
                ? theme?.palette?.primary?.main
                : "inherit",
            }}
          />
        </ControlButton>
        {/* Botão para listar e aplicar templates */}
        <ControlButton
          onClick={onAbrirTemplates}
          title="Templates"
          aria-label="Templates"
        >
          <DashboardCustomizeOutlined fontSize="small" />
        </ControlButton>
        {/* Botão para salvar configuração atual como novo template */}
        {editMode && (
          <ControlButton
            onClick={onSalvarTemplate}
            title={
              hasNodes
                ? "Salvar como template"
                : "Adicione equipamentos para salvar como template"
            }
            aria-label="Salvar como template"
            disabled={!hasNodes}
          >
            <SaveAsOutlined fontSize="small" />
          </ControlButton>
        )}
      </Controls>
    </Box>
  );
}
